import logo from 'assets/logo.png';

// ==============================|| NEXUS CX LOGO ||============================== //

const Logo = () => <img src={logo} alt="NEXUS CX" width="140" style={{ display: 'block', margin: '0 auto' }} />;

export default Logo;
